import { useNavigate } from "react-router-dom";
import i18next from "i18next";
import palette from "../../../theme/palette";
import {
  Wrapper,
  ContentCard,
  IllustrationWrapper,
  SkyBackground,
  PlaneWrapper,
  Cloud,
  CloudSlow,
  ErrorCode,
  Title,
  Description,
  HomeButton,
} from "./style";

const CloudIcon = () => (
  <svg viewBox="0 0 64 40" fill="currentColor">
    <path d="M52.8 16.8C52 8.4 44.8 2 36 2c-6.4 0-12 3.6-14.8 8.8C20 10.4 18.8 10 17.6 10 12 10 7.2 14.4 6.4 20 2.8 21.2 0 24.8 0 29.2 0 34.8 4.4 39.2 10 39.2h42c6.4 0 12-5.2 12-11.6 0-5.6-4-10.4-9.2-11.2-.8-.4-1.2-.8-2-.8z" />
  </svg>
);

const PlaneIcon = () => (
  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M85 45L65 35V20C65 15 60 10 55 10H45C40 10 35 15 35 20V35L15 45C12 46.5 10 49.5 10 53V58L35 53V70L25 75V82L50 77L75 82V75L65 70V53L90 58V53C90 49.5 88 46.5 85 45Z"
      fill={palette.primaryLight}
    />
    <path
      d="M85 45L65 35V20C65 15 60 10 55 10H50V77L75 82V75L65 70V53L90 58V53C90 49.5 88 46.5 85 45Z"
      fill={palette.primaryDark}
    />
    <ellipse cx="50" cy="30" rx="8" ry="5" fill={palette.primarySubtle} />
    <ellipse cx="50" cy="45" rx="6" ry="4" fill={palette.primarySubtle} />
  </svg>
);

export const NotFoundComponent = () => {
  const { t } = i18next;
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <Wrapper>
      <ContentCard>
        <IllustrationWrapper>
          <SkyBackground />

          <Cloud top="15%" right="-40px" delay={0} size={0.8}>
            <CloudIcon />
          </Cloud>
          <Cloud top="60%" right="-60px" delay={3} size={1}>
            <CloudIcon />
          </Cloud>
          <CloudSlow top="35%" right="-80px" delay={1.5} size={1.2}>
            <CloudIcon />
          </CloudSlow>
          <CloudSlow top="70%" right="-100px" delay={5} size={0.9}>
            <CloudIcon />
          </CloudSlow>

          <PlaneWrapper>
            <PlaneIcon />
          </PlaneWrapper>

          <ErrorCode>404</ErrorCode>
        </IllustrationWrapper>

        <Title>{t("not_found_title", "Страница не найдена")}</Title>

        <Description>
          {t(
            "not_found_description",
            "Похоже, этот рейс был отменён. Проверьте адрес или вернитесь на главную, чтобы найти новое направление!"
          )}
        </Description>

        <HomeButton onClick={handleGoHome}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            width={20}
            height={20}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
            />
          </svg>
          {t("go_to_home", "На главную")}
        </HomeButton>
      </ContentCard>
    </Wrapper>
  );
};
